import React from 'react'
import styles from './styles.css'
import {withRouter} from 'react-router'
import PropTypes from 'prop-types'
import Loading from 'orionsoft-parts/lib/components/Loading'
import Paginated from 'meteor-paginated-graphql-react'
import MdGroup from 'react-icons/lib/md/group'
import autobind from 'autobind-decorator'

@withRouter
export default class OrganizationUsers extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    organizationId: PropTypes.string
  }
  @autobind
  onSelect({userId}) {
    this.props.router.push(`/admin/${userId}`)
  }

  getFields() {
    return [
      {title: '', name: 'userId', render: () => <MdGroup />},
      {
        title: 'Email',
        name: 'email'
      },
      {
        title: 'Rol',
        name: 'roles'
      }
    ]
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <h3>Usuarios que pertenecen a la organización</h3>
          </div>
          <Paginated
            loadingComponent={Loading}
            queryName="adminOrganizationUsers"
            fields={this.getFields()}
            ref="paginated"
            organizationId={this.props.organizationId}
            params="$filter: String $organizationId: String"
            onPress={this.onSelect}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Admin/OrgInformation/OrganizationUsers/index.js